jQuery(document).ready(function($) {
	
	$.parallax = {

		init: function() {
            
			$(document).scroll(function() {
				var scrollPosTop = $(document).scrollTop();
				var scrollPosBottom = $(document).scrollTop()+$(window).height();

				$('.js-parallax').each(function() {

					var containerHeight = $(this).parents('.js-parallax-container').height();

					var containerWrapperOffset = $(this).parents('.js-parallax-container').parent().offset();
					var containerWrapperHeight = $(this).parents('.js-parallax-container').parent().outerHeight(true);

					var posTop = containerWrapperOffset.top;
					var posBottom = containerWrapperOffset.top + containerWrapperHeight;

					if(((posTop - 150) <= scrollPosBottom) && (posBottom >= scrollPosTop))
					{
						$(this).fadeIn(2000);

						var direction = 'top';
						var speed = 1;

						if($(this).data('direction')) {
							direction = $(this).data('direction');
						}

						if($(this).data('speed')) {
							speed = $(this).data('speed');
						}

						var y = 0;
						var eldirection = '';

						if(direction == 'top')
						{
							var pos = scrollPosBottom-posBottom;

							if(speed*pos < (containerHeight - $(this).height())) {
								y = speed*pos;
							} else {
								y = $(this).css('bottom');
							}
							
							eldirection = 'bottom';
						}
						else if(direction == 'bottom')
						{
							var pos = scrollPosBottom-posTop;

							if(speed*pos < (containerHeight - $(this).height())) {
								y = speed*pos;
							} else {
								y = $(this).css('top');
							}

							eldirection = 'top';
						}

						$(this).css(eldirection, y + 'px');
					}

				});
			});


        },
	
	};

});
